var _circle, _circle2, _circle3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    className: "lds-flickr",
    style: {
      background: "none"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    "ng-attr-cx": "{{config.cx1}}",
    cy: 50,
    "ng-attr-fill": "{{config.c1}}",
    "ng-attr-r": "{{config.radius}}",
    cx: 64.9971,
    fill: "#9ce4fe",
    r: 15
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    calcMode: "linear",
    values: "35;65;35",
    keyTimes: "0;0.5;1",
    dur: 0.7,
    begin: "-0.35s",
    repeatCount: "indefinite"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    "ng-attr-cx": "{{config.cx2}}",
    cy: 50,
    "ng-attr-fill": "{{config.c2}}",
    "ng-attr-r": "{{config.radius}}",
    cx: 35.0029,
    fill: "#e2f1fc",
    r: 15
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    calcMode: "linear",
    values: "35;65;35",
    keyTimes: "0;0.5;1",
    dur: 0.7,
    begin: "0s",
    repeatCount: "indefinite"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    "ng-attr-cx": "{{config.cx1}}",
    cy: 50,
    "ng-attr-fill": "{{config.c1}}",
    "ng-attr-r": "{{config.radius}}",
    cx: 64.9971,
    fill: "#9ce4fe",
    r: 15
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    calcMode: "linear",
    values: "35;65;35",
    keyTimes: "0;0.5;1",
    dur: 0.7,
    begin: "-0.35s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    values: "0;0;1;1",
    calcMode: "discrete",
    keyTimes: "0;0.499;0.5;1",
    "ng-attr-dur": "{{config.speed}}s",
    repeatCount: "indefinite",
    dur: "0.7s"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.20044c20e5640b6c481e2361289b14be.svg";
export { ForwardRef as ReactComponent };